type ButtonProps = {
  primary?: boolean;
  text?: string;
  onClick?: () => void;
  classes?: string;
  type?: 'button' | 'submit' | 'reset' | undefined;
  disabled?: boolean | null;
  testID?: string;
};
export function Button(props: ButtonProps) {
  return (
    <button
      className={`block text-center ${
        props.primary && !props.disabled ? 'hover:bg-periwinkle bg-periwinkle-200 hover:text-white' : ''
      } p-3 rounded-full text-lg w-full ${props?.classes} ${props?.disabled ? 'bg-stone' : ''}`}
      onClick={props?.onClick}
      type={props?.type || 'button'}
      disabled={props?.disabled ?? false}
      data-testid={props?.testID}>
      {props.text || 'Submit'}
    </button>
  );
}
